import Icon from '../components/Icon.vue'

Icon.register({
  democrat: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M637.3 256.9c4.9 7.4 2.9 17.3-4.4 22.3l-26.6 17.7c-7.4 4.9-17.3 3-22.2-4.4-21.8-32.7-23.9-38.1-40.1-50.3v77.8h-352l-54-108-38.1 34.6c-6 6-14.1 9.4-22.6 9.4h-31c-12.1 0-23.2-6.9-28.6-17.7l-14.3-28.6c-5.4-10.8-4.3-23.8 3-33.5l74.6-99.3c1.7-2.3 4.2-3.7 6.4-5.4-4-2.2-8-4.2-11.3-7.5-16.4-16.4-18.4-41.8-6.1-60.4 2.8-4.2 8.8-4.8 12.4-1.2l42.9 42.8 41.8-41.8c4.4-4.4 11.8-3.7 15.2 1.5 15.1 22.8 12.6 53.8-7.5 73.9l81.2 81.2h235.6c50.8 0 97.9 25.2 126.1 67.5zM296.2 243.3c3-2.9 1.4-7.9-2.6-8.5l-22.8-3.3-10.2-20.7c-1.9-3.7-7.2-3.7-9 0l-10.2 20.7-22.8 3.3c-4.1 0.6-5.8 5.6-2.8 8.5l16.5 16.1-3.9 22.7c-0.7 4.1 3.6 7.2 7.2 5.3l20.4-10.7 20.4 10.7c3.6 1.9 7.9-1.2 7.2-5.3l-3.9-22.7zM408.2 243.3c3-2.9 1.4-7.9-2.6-8.5l-22.8-3.3-10.2-20.7c-1.9-3.7-7.2-3.7-9 0l-10.2 20.7-22.8 3.3c-4.1 0.6-5.8 5.6-2.8 8.5l16.5 16.1-3.9 22.7c-0.7 4.1 3.6 7.2 7.2 5.3l20.4-10.7 20.4 10.7c3.6 1.9 7.9-1.2 7.2-5.3l-3.9-22.7zM520.2 243.3c3-2.9 1.4-7.9-2.6-8.5l-22.8-3.3-10.2-20.7c-1.9-3.7-7.2-3.7-9 0l-10.2 20.7-22.8 3.3c-4.1 0.6-5.8 5.6-2.8 8.5l16.5 16.1-3.9 22.7c-0.7 4.1 3.6 7.2 7.2 5.3l20.4-10.7 20.4 10.7c3.6 1.9 7.9-1.2 7.2-5.3l-3.9-22.7zM192 496v-144h352v144c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-80h-160v80c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/democrat.js
// module id = 1257
// module chunks = 0